import { DrawCustomMode } from "@mapbox/mapbox-gl-draw";
import { SnapLineMode, Utils } from "mapbox-gl-draw-snap-mode";

const drawLineString: DrawCustomMode = {
  ...SnapLineMode,

  onSetup: function (opts) {
    const state = SnapLineMode.onSetup?.call(this, opts);

    // We don't use the snapping guides added during setup so we remove them to avoid having to delete them later
    this.deleteFeature(Utils.IDS.HORIZONTAL_GUIDE, { silent: true });
    this.deleteFeature(Utils.IDS.VERTICAL_GUIDE, { silent: true });

    return state;
  },
};

export default drawLineString;
